import { render } from "./KioskRegistrationView.vue?vue&type=template&id=20a53519"
import script from "./KioskRegistrationView.vue?vue&type=script&lang=js"
export * from "./KioskRegistrationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__